import { DatabaseEnvironments } from "../types/db_management_types";

export function getDatabaseEnvironmentLabel(value: number): string {

    return (
        DatabaseEnvironments.find(env => env.value === value)?.label ??
        "Unknown Environment"
    );
}
